module.exports = __webpack_public_path__ + "img/1539836869.90f6639a.jpg";